<template>
    <Paper :style="fullHeight ? 'height: 100%' : ''">
        <div class="search-section">
            <SearchBar
                v-if="!hideSearch"
                v-model="search"
                :disabled="disableSearch"
                :onSearch="update"
                :useAutocomplete="false"
            />
            <!-- useAutocomplete needs to be dependent 
                on whether you are searching for jobs or companies. 
                The autocomplete in companies makes little sense right now. -->
            <SearchSuggestion :value="search" />
        </div>

        <template v-if="filters">
            <Divider />
            <Filters
                :filterOrientation="filterOrientation"
                v-if="filters && filters.length > 0"
                :value="value"
                :filters="filters"
                v-on:update:filter="updateFilter"
                v-on:clear:filter="clearFilter"
                :hasFiltersChanged="hasFiltersChanged"
            />
        </template>

        <template v-if="$slots.default">
            <Divider />
            <slot />
        </template>
    </Paper>
</template>

<script>
import SearchBar from './SearchBar';
import Filters from './Filters';
import SearchSuggestion from './SearchSuggestion';

export default {
    components: { SearchBar, Filters, SearchSuggestion },
    props: {
        disableSearch: {
            type: Boolean,
            default: false,
        },
        hideSearch: {
            type: Boolean,
            default: false,
        },
        fullHeight: {
            type: Boolean,
            default: false,
        },
        filters: Array,
        value: Object,
        hasFiltersChanged: Boolean,
        filterOrientation: String,
    },
    data: () => ({
        search: '',
    }),
    methods: {
        updateFilter(val) {
            if (this.search) {
                this.$emit('input', {
                    ...val,
                    query: this.search,
                });
            } else {
                delete val.query;

                this.$emit('input', {
                    ...val,
                });
            }
            this.$emit('filter:change');
        },
        clearFilter() {
            this.$emit('clear:filter', {});
        },
        update() {
            this.updateFilter(this.value);
        },
    },
    watch: {
        value(newVal) {
            if (newVal && newVal.query) {
                this.search = newVal.query;
            }
        },
    },
};
</script>

<style scoped>
.search-section {
    position: relative;
}
</style>
